// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'dd81f3232f3db23a60f1b146d1029682bf0ba701';
export const BUILD_NUMBER = '248';
export const BUILD_TIMESTAMP = '2026-09-22T07:12:30.424Z';
